import CarouselCard from 'components/OfferList/OfferCards/CarouselCard'
import React from 'react'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton'
import OfferBadgeTag from 'components/Common/OfferBadgeTag'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import LEOfferPriceDetails from './LEOfferPriceDetails'
import { isCruiseV1Offer } from 'lib/offer/offerTypes'
import CruiseFlashPriceDetails from './CruiseFlashPriceDetails'
import CruiseFlashDescription from './CruiseFlashDescription'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import { isUltraLuxOffer } from 'lib/offer/offerUtils'

interface Props {
  offer: App.Offer | App.OfferSummary
  onClick: () => void
  className?: string;
  offerUrl: string;
}

function TourOfferCard({ offer, onClick, className, offerUrl }: Props) {
  const palette = isUltraLuxOffer(offer) ? 'ultralux' : 'default'
  return (
    <ProductPaletteProvider palette={palette}>
      <CarouselCard
        className={className}
        bookmarkButton={<BookmarkButton offer={offer} />}
        image={offer.image}
        location={offer.location}
        title={offer.name}
        offerUrl={offerUrl}
        onClick={onClick}
        urgencyLabels={<LabelGroup>
          {offer.badge && <OfferBadgeTag badge={offer.badge} />}
        </LabelGroup>}
        description={
          isCruiseV1Offer(offer) ?
            <CruiseFlashDescription offer={offer} /> :
            undefined
        }
        offerPriceDetails={
          isCruiseV1Offer(offer) ?
            <CruiseFlashPriceDetails offer={offer} /> :
            <LEOfferPriceDetails offer={offer} />
        }
      />
    </ProductPaletteProvider>
  )
}

export default TourOfferCard
